export default __webpack_public_path__ + "static/media/mainlogo.12584ea1.png";